import { render, staticRenderFns } from "./AccountHolderDashboard.vue?vue&type=template&id=d544dcf6&scoped=true"
import script from "./AccountHolderDashboard.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDashboard.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderDashboard.vue?vue&type=style&index=0&id=d544dcf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d544dcf6",
  null
  
)

export default component.exports